      import {APIURL, SOCKETURL } from "../../Global";
      import axios from "axios";
      import React, { useContext, useState, useEffect, useRef } from "react";
      function Notificationbadge(props) {
      const [refresh, setRefresh] = useState(false);
  const [login_datas, setLogin_datas] = useState(
    JSON.parse(sessionStorage.getItem("logindatas"))
      ? JSON.parse(sessionStorage.getItem("logindatas"))
      : null
  );
    useEffect(() => {
          if(login_datas&&(login_datas.user_type === 'hospital_bdo' || login_datas.user_type === 'hospital_pro')){
          const tokenString = sessionStorage.getItem("usertoken");
          const token = tokenString ? tokenString.replace(/["]+/g, "") : "";
  
          axios.get(`${APIURL}/api/v1/service-provider/notification-badges/`, {
              headers: {
                  Authorization: `Token ${token}`,
              }
          })
          .then(res => {
              // Example response: { dialysis: 2, physio: 1, palliative: 3 }
              if (res.data.status === 'success') {
                  props.setDiaCount&&props.setDiaCount(res.data.dialysis_count);
                  props.setPhyCount&&props.setPhyCount(res.data.physio_count);
                  props.setPalCount&&props.setPalCount(res.data.palliative_count);
                      
              }
          })
          .catch(err => {
              console.error("Failed to fetch notification badges:", err);
          });
      }
      }, [refresh]);
   useEffect(() => {
       if(login_datas&&(login_datas.user_type === "hospital_pro"||login_datas.user_type === "hospital_bdo")) {

        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString.replace(/["]+/g, "");

        const physioWS = new WebSocket(`${SOCKETURL}/ws/notifications/physiotherapy/?token=${token}`);
        const dialysisWS = new WebSocket(`${SOCKETURL}/ws/notifications/dialysis/?token=${token}`);
        const palliativeWS = new WebSocket(`${SOCKETURL}/ws/notifications/palliative/?token=${token}`);

        physioWS.onmessage = (evt) => {
            const data = JSON.parse(evt.data);
            setRefresh(!refresh);
        };

        dialysisWS.onmessage = (evt) => {
            const data = JSON.parse(evt.data);
            setRefresh(!refresh);

        };

        palliativeWS.onmessage = (evt) => {
            const data = JSON.parse(evt.data);
            setRefresh(!refresh);
         
        };

        // Optionally log connections
        physioWS.onopen = () => console.log("Physio WebSocket connected");
        dialysisWS.onopen = () => console.log("Dialysis WebSocket connected");
        palliativeWS.onopen = () => console.log("Palliative WebSocket connected");

        return () => {
            physioWS.close();
            dialysisWS.close();
            palliativeWS.close();
        };
      }
    }, []);
return(
    <div></div>
)
}
export default Notificationbadge;